import { http } from '@/shared/api/http';

export interface MeResponse {
  id: string;
  email: string;
  role: 'user' | 'platform_admin';
  full_name?: string;
  phone?: string;
  avatar_url?: string;
  preferences?: {
    locale?: 'ru' | 'en';
    default_currency?: string;
  };
  organization?: {
    id: string;
    name: string;
    tariff_code?: string;
    valid_to?: string;
    status?: string;
  };
}

export interface UpdateMeBody {
  full_name?: string;
  phone?: string;
  preferences?: {
    locale?: 'ru' | 'en';
    default_currency?: string;
  };
}

export interface Currency {
  code: string;
  symbol: string;
  decimals: number;
  is_active: boolean;
}

export function getMe(): Promise<MeResponse> {
  return http<MeResponse>('/me');
}

export function updateMe(body: UpdateMeBody): Promise<MeResponse> {
  return http<MeResponse>('/me', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function changePassword(body: {
  current_password: string;
  new_password: string;
}): Promise<void> {
  return http<void>('/me/password', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function uploadAvatar(file: File): Promise<{ avatar_url: string }> {
  const fd = new FormData();
  fd.append('file', file);
  return http<{ avatar_url: string }>('/me/avatar', {
    method: 'POST',
    body: fd,
  });
}

export function getCurrencies(): Promise<Currency[]> {
  return http<Currency[]>('/currencies');
}
